import React from "react";
import { LegalPage } from "@/pages/PrivacyPolicy";

export default function CookiePolicy() {
  return <LegalPage pageKey="cookie" />;
}
